import {experimentation} from '@microsoft/office-experimentation-web';
import {CHANGE_GATE_PREFIX} from '../AppConstants';

// The online config is used to check if the tenant id is eligible for unlimited file upload minutes
export const unlimitedUploadTenants = 
  experimentation.getStringFeatureGate(
  CHANGE_GATE_PREFIX + 'unlimitedUploadTenants',
  '',
);